// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  targetKind: __t.string().name("target_kind"),
  targetId: __t.string().name("target_id"),
  principalKind: __t.string().name("principal_kind"),
  principalId: __t.string().name("principal_id"),
  role: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
